module.exports = __webpack_public_path__ + "img/1-8.e2203442.png";